import React from 'react';
import { Jumbotron, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import classes from './JumbotronMenuItem.module.scss';

const JumbotronMenuItem = (props) => {
  const {
    urlPrefix,
    insuranceName,
    img,
    hasBorder,
    hasBorderOld,
    insuranceName2
  } = props;
  const isSeniorCard = urlPrefix === 'senior2026';

  return (
    <Col xs="12" lg="6">
      <Jumbotron
        className={`${classes.jumbotron} ${
          isSeniorCard ? classes.seniorCard : ''
        }`}
        style={{
          backgroundImage: `url('${process.env.PUBLIC_URL}/tvp/dashboard/${img}.jpg')`
        }}>
        <div className={classes.content}>
          <div className={classes.textBlock}>
            {insuranceName && (
              <Link to={`/${urlPrefix}/opis/`} style={{ color: 'white' }}>
                <h2 className={classes.title}>{insuranceName}</h2>
              </Link>
            )}
            {insuranceName2 && (
              <Link to={`/${urlPrefix}/opis/`} style={{ color: 'white' }}>
                <h3 className={classes.subtitle}>{insuranceName2}</h3>
              </Link>
            )}
          </div>

          <div className={classes.buttons}>
            <Link
              className={`${classes.ctaButton} ${classes.primaryButton}`}
              to={`/${urlPrefix}/opis`}>
              <i className="fa fa-chevron-circle-right" /> Zobacz opis
            </Link>
            {!props.disabledButton && (
              <Link
                className={`${classes.ctaButton} ${classes.secondaryButton}`}
                to={`/${urlPrefix}/kup/`}>
                <i className="fa fa-chevron-circle-right" /> Wypełnij deklarację
              </Link>
            )}
          </div>
        </div>

        {hasBorder && <div className={classes.badge}>Nowy produkt 2026</div>}
        {hasBorderOld && <div className={classes.badge2}>Stary produkt</div>}
      </Jumbotron>
    </Col>
  );
};

export default JumbotronMenuItem;
